<template>
    <span
        v-html="svg(name, 'icon-' + name)"
        :class="noWrapClass ? '' : 'icon-wrap'"
    />
</template>

<style lang="scss" scoped>
span {
    display: inline-block;
}
</style>

<script>
export default {
    props: {
        name: {
            type: String,
            required: true
        },
        noWrapClass: {
            type: Boolean,
            default: false
        }
    }
};
</script>
